module.exports = __webpack_public_path__ + "img/logo_mx.fd41d59c.png";